import request from '../utils/request'

// 资讯列表
export const getnewsList = (data) => {
    return request({
        url: '/buyer/news/list',
        method: 'POST',
        data
    })
}
// 资讯详情
export const getnewsdetail = (data) => {
    return request({
        url: '/buyer/news/detail',
        method: 'POST',
        data
    })
}

// 发布评论
export const commmentSave = (data) => {
    return request({
        url: '/buyer/commment/save',
        method: 'POST',
        data
    })
}
// 查询评论
export const commmentFind = (data) => {
    return request({
        url: '/buyer/commment/findByPage',
        method: 'POST',
        data
    })
}
// 添加收藏
export const collectSave = (data) => {
    return request({
        url: '/buyer/collect/save',
        method: 'POST',
        data
    })
}
// 取消收藏
export const collectUnSave = (data) => {
    return request({
        url: '/buyer/collect/deleteByObjId',
        method: 'GET',
        params: data
    })
}
// 点赞
export const praiseSave = (data) => {
    return request({
        url: '/buyer/praise/save',
        method: 'POST',
        data
    })
}
// 取消点赞
export const praiseUnSave = (data) => {
    return request({
        url: '/buyer/praise/deleteByObjId',
        method: 'GET',
        params: data
    })
}